/**
 * Content Verification Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApikeyModel } from './apikeyModel';


export interface PaginatedModelOfApikeyModel { 
    tList?: Array<ApikeyModel>;
    tListCount: number;
    filteredCount: number;
}
